const React = require("react");
const {object, string} = require("yup");
const {FormWrapper, FormFooterAgreement} = require("../../../../../../../dumb/FormHandlers");
const {apiAdminWithdrawProcessingStart} = require('../../../../../../../../api/admin/withdraws');
const {AdminInputPassword} = require("../../../../../../../dumb/FormInputs");

module.exports = ({data, update, close}) => {

  const resultModalData = [
    'Successful processing start',
    `You\'ve completed start of withdrawal request processing for #${data.id}.`
  ];

  const onSubmit = ({confirmBearer}) => (
    apiAdminWithdrawProcessingStart({withdraw_id: data.id, confirmBearer})
  );

  const onResult = () => {
    update();
    close();
  }

  return (
    <FormWrapper
      schema={object({
        confirmBearer: string().required()
      })}
      onSubmit={onSubmit}
      resultModalData={resultModalData}
      onResult={onResult}
    >{(formCtx) => (
      <>
        <div className="mt20">
          <AdminInputPassword label="Password" name="confirmBearer" formCtx={formCtx} />
        </div>
        <FormFooterAgreement
          submitBtnData={{
            text: 'Proceed',
            formCtx
          }}
          additionalBtnsList={[
            {
              text: 'Cancel',
              onClick: close
            }
          ]}
        />
      </>
    )}</FormWrapper>
  )
}
